import { Helmet } from "react-helmet-async";
import TabsMAIQ from "app/components/TabsMAIQ";
import UsersTab from "./components/user/UsersTab";
import DealersTab from "./components/dealer/DealersTab";
import TDealershipGroupTab from "./components/dealerGroup/DealershipGroupTab";
import { UserProvider } from "app/context/UserContext";
import { DealerProvider } from "app/context/DealerContext";
import { DealerGroupProvider } from "app/context/DealerGroupContext";
import { RoleProvider } from "app/context/RoleContext";
import { PageContainer, PageHeader } from "app/components/StyledComponents";
import { BreadcrumbsComponent } from "app/components/BreadcrumbsComponent";

const UserManagementPage = () => {
  const tabsData = [
    { label: "USERS", content: <UsersTab /> },
    { label: "DEALERS", content: <DealersTab /> },
    { label: "DEALERSHIP GROUPS", content: <TDealershipGroupTab /> },
  ];

  const breadcrumbsList = [
    { label: "User Management", isActive: true }
  ];

  return (
    <>
      <Helmet>
        <title>User Management</title>
        <meta name="description" content="Manage User Informations" />
      </Helmet>
      <PageContainer>
        <BreadcrumbsComponent breadcrumbsList={breadcrumbsList} />
        <PageHeader>User Management</PageHeader>
        <TabsMAIQ tabs={tabsData} />
      </PageContainer>
    </>
  );
};

export default UserManagementPage;
